module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e40058311"
    }
  }, [_c('span', [_c('a', {
    staticClass: "sgc-1",
    attrs: {
      "href": "#/Text/Hunt_9781401684952_epub_c17_r1#d6e35",
      "id": "d7e35"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e40069311"
    }
  }, [_c('span', [_c('span', {
    staticClass: "dcap2 sgc-2",
    attrs: {
      "id": "d14e8411"
    }
  }, [_vm._v("R")]), _vm._v("eese Mackenzie swept her hand over the old wall as if she could perceive the secrets beneath it. Regardless of what the ugly wallpaper hid, in two months she’d be living her dream.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40087311"
    }
  }, [_c('span', [_vm._v("“You should definitely take the walls down,” Griffen Parker said. He closed the space between them and knocked on the drywall. “Bet there’s brick under there.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40100311"
    }
  }, [_c('span', [_vm._v("Reese met his clear blue eyes. A dark lock of hair fell over his forehead and battled with his eyelashes.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40110311"
    }
  }, [_c('span', [_vm._v("“I’d planned on painting. You never know what’s behind these old walls. The only way to find out is to knock them down, and once you do that, there’s no turning back.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40124311"
    }
  }, [_c('span', [_vm._v("“Can’t be worse than this,” he said, running his hand over the Pepto-Bismol wallpaper. “Besides, it’ll take forever to remove this stuff.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40137311"
    }
  }, [_c('span', [_vm._v("He was right about that, but she hated changing boats midstream. “I’ll think about it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40147311"
    }
  }, [_c('span', [_vm._v("She couldn’t believe the Palmer Building was all hers now.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40152311"
    }
  }, [_c('span', [_vm._v("Well, hers and the bank’s. There was so much work to do, and so many unknowns. She’d been planning this forever, but that didn’t stop the worry from jangling on her nerves.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40165311"
    }
  }, [_c('span', [_vm._v("Reese crossed the open space, her Merrell boots barely making a sound on the wooden planks. “You don’t see a problem structurally with opening up the second floor?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40181312"
    }
  }, [_c('span', [_vm._v("He pocketed his hands in his vest coat. “Nope. The bones are solid.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40191312"
    }
  }, [_c('span', [_vm._v("Reese glanced around the space, her imagination kicking in. “I want lots of cubbies and shelving.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40201312"
    }
  }, [_c('span', [_vm._v("“Of course you do.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40208312"
    }
  }, [_c('span', [_vm._v("“A place for everything.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40215312"
    }
  }, [_c('span', [_vm._v("“I expected no less.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40223312"
    }
  }, [_c('span', [_vm._v("It was going to take a lot of time. She hoped it wouldn’t put Griffen in a bind with his other clients. She knew he’d do anything for her, but she’d never take advantage of their friendship.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40239312"
    }
  }, [_c('span', [_vm._v("She studied his face. He’d changed since he left Smitten three years earlier. His hair was longer, dangling over his forehead and curling up on the ends. And he always seemed to be sporting a five o’clock shadow. Probably didn’t have time to shave, with all his projects.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40258312"
    }
  }, [_c('span', [_vm._v("“You sure you have time for all this—you’d tell me if you didn’t, right?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40268312"
    }
  }, [_c('span', [_vm._v("He cocked a grin. “Always have time for my favorite girl. I’ll finish the town’s gazebo tomorrow, and I figured this project would be my last. I’m all yours for the next two months.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40284312"
    }
  }, [_c('span', [_vm._v("“Only if you’re absolutely, positively sure . . .”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40291312"
    }
  }, [_c('span', [_vm._v("“You want it in blood?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40299312"
    }
  }, [_c('span', [_vm._v("She shot him a look, then returned to her perusal of her very own building. “That would leave me a week to arrange the merchandise before the wedding. I’ll be ready in plenty of time to assist the wedding guests with all their recreational needs.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40313312"
    }
  }, [_c('span', [_vm._v("She’d already ordered everything from ski poles to canoes.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40319312"
    }
  }, [_c('span', [_vm._v("Opened boxes filled her spare rooms, and a variety of boats and bikes had usurped her car’s spot in the garage. Each shipment filled her with excitement . . . and worry. What if this whole plan was one massive failure? "), _c('i', [_vm._v("Please, God. You know we’re trying to step out on faith here, right?")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40345313"
    }
  }, [_c('span', [_vm._v("“Obviously, you’ll need new plumbing. And the heating system is archaic.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40355313"
    }
  }, [_c('span', [_vm._v("“Just write it up and give me a ballpark figure.” She nailed him with a look. “And be fair. I’m not a charity case.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40365313"
    }
  }, [_c('span', [_vm._v("He tipped a grin her way. “Speaking of ballpark, I’ve been home for almost eight months, and you haven’t even been over to shoot hoops yet. What’s up with that? What d’ya say—have time for some one-on-one?” He put up an invisible shot. “My place came with a court, you know.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40384313"
    }
  }, [_c('span', [_vm._v("He was renting the old Halverson place, which had been on the market since the mill closed.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40395313"
    }
  }, [_c('span', [_vm._v("“In case you haven’t noticed, it’s winter. Besides, I’m having coffee with the girls in an hour, and I was going to browse a new sporting goods catalog.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40408313"
    }
  }, [_c('span', [_vm._v("“New plan.” He nudged her. “Come on, it’s almost forty, and the ground’s clear. We have almost an hour of daylight, and you’ve been stuck behind a desk all day.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40421313"
    }
  }, [_c('span', [_vm._v("“Not anymore,” she fairly sang. Today had been her last day as the receptionist for Smitten Accounting. Her colleagues had ordered some chocolate heaven from Piece of Cake to celebrate her new start.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40437313"
    }
  }, [_c('span', [_vm._v("He pulled her toward the door. “You can catch me up on the scuttlebutt on the way.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40447313"
    }
  }, [_c('span', [_vm._v("She flipped off the lights on her way out and pulled the old door with its wavy paneled glass. The wreath bounced against the door as it hit the jamb.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40464314"
    }
  }, [_c('span', [_vm._v("“Here’s the scuttlebutt,” she said, donning her Thinsulate gloves. “Natalie’s practically engaged, Julia’s planning her wedding, Shelby and Nick are glued at the hip, and I’ve become the resident town spinster.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40480314"
    }
  }, [_c('span', [_vm._v("Griffen chuckled and ruffled her hair. “Aw, poor little Reese Cup. Feeling left out of the lovers’ loop?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40490314"
    }
  }, [_c('span', [_vm._v("She took her knit cap from her pocket and pulled it on, sighing. “Nah, I’m happy for them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40500314"
    }
  }, [_c('span', [_vm._v("Reese would’ve been the first married if things had been different. Her whole life would be different if she and Sawyer had worked out. "), _c('i', [_vm._v("Reese Smitten")]), _vm._v(". So it didn’t exactly roll off the tongue. Didn’t matter now anyway. He was set to marry a Hollywood beauty and save the town of Smitten in one fell swoop.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40527314"
    }
  }, [_c('span', [_vm._v("They crossed the brick street, dodging the diagonally parked cars in front of Smitten Hardware. The town was decked out for Christmas. Garlands spiraled up streetlamps and swagged across storefronts. Window boxes of poinsettias decked the buildings, and sparkling new ornaments dangled from the newly planted pine trees in the town square.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40551314"
    }
  }, [_c('span', [_vm._v("This would all be gone by Sawyer’s wedding. The multicolored lights would be replaced with twinkling white ones, and the poinsettias would be traded in for artificial sprays of white peonies or something. What would it be like, seeing Sawyer again, with someone else? Marrying someone else?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40570314"
    }
  }, [_c('span', [_vm._v("“Whatever happened with you and Sawyer after I left?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40575314"
    }
  }, [_c('span', [_vm._v("You never said.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40582314"
    }
  }, [_c('span', [_vm._v("“How do you do that?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40589314"
    }
  }, [_c('span', [_vm._v("“What?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40596314"
    }
  }, [_c('span', [_vm._v("“Read my mind.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40606315"
    }
  }, [_c('span', [_vm._v("He shrugged and turned a crooked grin on her, exhaling a puff of fog between them. His nose was already pink.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40616315"
    }
  }, [_c('span', [_vm._v("Ahead of them, a couple turned into Natalie’s shop.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40621315"
    }
  }, [_c('span', [_vm._v("Reese and Griffen continued to the corner and turned up Maple, heading toward his place. She hadn’t forgotten his question, and he knew her well enough to know she’d get back to it eventually.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40638315"
    }
  }, [_c('span', [_vm._v("She and Sawyer . . . it seemed like a lifetime ago.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40645315"
    }
  }, [_c('span', [_vm._v("She shrugged, picking up their conversation. “Once he won "), _c('i', [_vm._v("Country’s Best")]), _vm._v(", everything changed, you know? He was offered a recording contract. He could hardly turn it down.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40660315"
    }
  }, [_c('span', [_vm._v("Realizing she was still making excuses for him, she sighed.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40666315"
    }
  }, [_c('span', [_vm._v("It didn’t help that his new fiancée, with her blond hair and greenish eyes, looked a lot like his old one. Well. The shorter, less glamorous version.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40679315"
    }
  }, [_c('span', [_vm._v("“And you couldn’t leave your mom.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40687315"
    }
  }, [_c('span', [_vm._v("“I was all she had.” The Parkinson’s had already taken her mom’s mobility by then. It had been the hardest thing she’d ever experienced, watching her mom waste away.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40700315"
    }
  }, [_c('span', [_vm._v("“I’m sorry I wasn’t here when she passed. You don’t know how much I regret that.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40710315"
    }
  }, [_c('span', [_vm._v("“It’s okay. I had the girls. I was just worried when I couldn’t reach you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40720315"
    }
  }, [_c('span', [_vm._v("Griffen had been on a Habitat for Humanity project somewhere in Mexico, and she hadn’t located him until after the funeral.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40733315"
    }
  }, [_c('span', [_vm._v("“I’m sorry.” He looked miserable.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40740315"
    }
  }, [_c('span', [_vm._v("“Bygones,” she said, their favorite word from their high school days.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40751315"
    }
  }, [_c('span', [_vm._v("That earned her a smile.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40761316"
    }
  }, [_c('span', [_vm._v("They turned up his gravel lane and walked toward the two-story structure he’d rented.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40771316"
    }
  }, [_c('span', [_vm._v("“That thing’s big enough for a family of ten.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40778316"
    }
  }, [_c('span', [_vm._v("“It was available—and cheap. Besides, I always liked the old place. Who knows, maybe I’ll buy it someday.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40788316"
    }
  }, [_c('span', [_vm._v("“You planning on ten kids?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40795316"
    }
  }, [_c('span', [_vm._v("“Maybe.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40803316"
    }
  }, [_c('span', [_vm._v("“Might want to start with a wife.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40810316"
    }
  }, [_c('span', [_vm._v("“I plan on it.” He tossed her a grin, and Reese felt a jolt at the thought of Griffen with a wife. She’d been his for so long—okay, not "), _c('i', [_vm._v("his")]), _vm._v(", but still. A wife wouldn’t appreciate another woman in his life, even if they were just best buddies.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40829316"
    }
  }, [_c('span', [_vm._v("She recalled the day last fall when she’d noticed him across the grocery store parking lot. The attraction she’d felt before she’d recognized him, the comment she’d made to Shelby. Even now, her face went ten degrees hotter. She glanced at Griffen, hoping he’d attribute the flush of her cheeks to the cold.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40848316"
    }
  }, [_c('span', [_vm._v("He slipped inside the detached garage and flipped a switch. The light by the door flickered on with a buzz. She set down her purse and checked out the court, a concrete slab with a wooden pole and a backboard that had seen better days.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40862316"
    }
  }, [_c('span', [_vm._v("At least the net was still there.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40870316"
    }
  }, [_c('span', [_vm._v("Griffen exited the building, dribbling the basketball toward the court. “Gotta warn you. I’ve been practicing.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40880316"
    }
  }, [_c('span', [_vm._v("Reese pulled off her gloves and rubbed her hands together.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40885316"
    }
  }, [_c('span', [_vm._v("She bent her knees in a defensive position as he approached.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40890316"
    }
  }, [_c('span', [_vm._v("“I’m so scared.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40897316"
    }
  }, [_c('span', [_vm._v("“You should be.” He darted around her, but she blocked his path, waving her arms.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40908316"
    }
  }, [_c('span', [_vm._v("“You’re still fast.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40918317"
    }
  }, [_c('span', [_vm._v("“May be a spinster, but I’m an active—”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40925317"
    }
  }, [_c('span', [_vm._v("He sidestepped and made an easy layup. "), _c('i', [_vm._v("Swish")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40936317"
    }
  }, [_c('span', [_vm._v("He jumped around her and grabbed the ball, swaggering back. “Like I said. Should I take it down a notch for you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40946317"
    }
  }, [_c('span', [_vm._v("He threw the ball, and she caught it at her chest, leveling him with a look as she dribbled the ball out. “You’re gonna be the one begging for mercy, pal.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40959317"
    }
  }, [_c('span', [_vm._v("“Bring it on, sister.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40967317"
    }
  }, [_c('span', [_vm._v("Thirty minutes later their coats were discarded in a heap, they were fogging up the court, and they were tied at sixteen.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40975317"
    }
  }, [_c('span', [_vm._v("What Reese lacked in size, she made up for in accuracy and speed.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40980317"
    }
  }, [_c('span', [_vm._v("She put a guard on Griffen all the way to the basket. He put up a shot that banked off the board and bounced on the rim before going in.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e40994317"
    }
  }, [_c('span', [_vm._v("“’Bout time,” she said. He’d missed his last three.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41001317"
    }
  }, [_c('span', [_vm._v("He gave her ponytail a tug. “Still up by one, Reese Cup.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41006317"
    }
  }, [_c('span', [_vm._v("She dribbled the ball out, then back toward him. “Not for long.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41016317"
    }
  }, [_c('span', [_vm._v("He crouched as she approached, his eyes on hers. She was going to dart around him and go in for an easy layup.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41026317"
    }
  }, [_c('span', [_vm._v("He swatted at the ball, and she dribbled it through her legs, catching it with her other hand.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41036317"
    }
  }, [_c('span', [_vm._v("“Nice move.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41044317"
    }
  }, [_c('span', [_vm._v("He swatted again, this time getting the prize.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41051317"
    }
  }, [_c('span', [_vm._v("She growled as he checked the ball out, then got between him and the basket before he could move in for an easy layup.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41059317"
    }
  }, [_c('span', [_vm._v("She had to force the jump shot, his weakness. She pressed in, squeezing. He couldn’t get around her—she was too fast.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41068317"
    }
  }, [_c('span', [_vm._v("Smallness had its advantages.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41075317"
    }
  }, [_c('span', [_vm._v("He faked left, but she was there. He faked right. She chuckled. He spun and darted forward. She was fast, right there in front of him, but he didn’t anticipate that.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41093318"
    }
  }, [_c('span', [_vm._v("His body plunged into hers as he went in for the layup.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41098318"
    }
  }, [_c('span', [_vm._v("She was falling backward. He caught her around the waist, pulling her toward him. His feet tangled with hers. She grabbed onto his shirt.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41111318"
    }
  }, [_c('span', [_vm._v("But it was too late. They were both going down.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41118318"
    }
  }, [_c('span', [_vm._v("Reese hit the ground hard. Griffen landed on her, and her breath left in one sudden expulsion. “Umph.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41128318"
    }
  }, [_c('span', [_vm._v("She felt the fall a full second later.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41136318"
    }
  }, [_c('span', [_vm._v("“Reese!” Griffen slid off to the side.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41143318"
    }
  }, [_c('span', [_vm._v("The sky overhead was darkening. The skeletal branch of an oak tree jutted across the blue canvas.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41153318"
    }
  }, [_c('span', [_vm._v("“Are you okay?” Griffen asked. “Reese?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41160318"
    }
  }, [_c('span', [_vm._v("“Give me a minute.” At least she hadn’t hit her head. Had she? Her backside killed. Her shoulder blade hurt. Nothing too bad, she didn’t think.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41173318"
    }
  }, [_c('span', [_vm._v("Assessing her injuries, she became aware of Griffen’s body, still pressed against her side. A strange sensation moved through her limbs, winging its way to her stomach, where a ribbon of warmth unfurled. Her heart thudded heavily in her chest.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41192318"
    }
  }, [_c('span', [_vm._v("What the— “Reese, talk to me. Did you hit your head?” He propped his weight on his elbow and brushed a loose strand of hair from her face.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41209318"
    }
  }, [_c('span', [_vm._v("The sensation sent a shiver down her spine, and she realized with dismay that she wanted him to touch her again.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41219318"
    }
  }, [_c('span', [_vm._v("“I’m fine,” she croaked.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41229319"
    }
  }, [_c('span', [_vm._v("So. Not. Fine. She met his eyes, dazed, confused, but not by the fall.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41239319"
    }
  }, [_c('span', [_vm._v("His brows furrowed. “What hurts?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41246319"
    }
  }, [_c('span', [_vm._v("She closed her eyes before he could read what was there.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41251319"
    }
  }, [_c('span', [_vm._v("Better he think her hurt than crazy. And it was crazy. This was Griffen, for pity’s sake.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41261319"
    }
  }, [_c('span', [_vm._v("He turned her face toward him. “Reese.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41268319"
    }
  }, [_c('span', [_vm._v("She brushed his hand away. “Quit. I’m fine.” She needed to leave, needed to ice her head whether she’d hit it or not.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41282319"
    }
  }, [_c('span', [_vm._v("“Maybe you should lie—”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41289319"
    }
  }, [_c('span', [_vm._v("“I said I’m fine!” She pushed at him, and he rolled away, standing.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41299319"
    }
  }, [_c('span', [_vm._v("He held out his hand, but she ignored it. No more touching. Not until she checked into the psych ward. Man, she was such a freak. This was "), _c('i', [_vm._v("Griffen")]), _vm._v(". She rose gingerly to her feet, brushed the gravel bits from her palms.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41319319"
    }
  }, [_c('span', [_vm._v("“I’m sorry, Reese. Did you hit your head? Come inside, we’ll ice it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41329319"
    }
  }, [_c('span', [_vm._v("She checked her watch. “I have to go.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41336319"
    }
  }, [_c('span', [_vm._v("He took her elbow. “You’re hurt.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41344319"
    }
  }, [_c('span', [_vm._v("She pulled away, glaring.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41351319"
    }
  }, [_c('span', [_vm._v("He backed off, his eyes widening. “I’m sorry. I shouldn’t have been so aggressive.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41361319"
    }
  }, [_c('span', [_vm._v("She sighed and waved him off, then went to gather her coat and purse. Twilight had closed in and a cacophony of night sounds had begun. Or maybe that was in her head.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41374319"
    }
  }, [_c('span', [_vm._v("“Reese . . .” She heard the worry in his voice, and some part of her reacted to that.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41388320"
    }
  }, [_c('span', [_vm._v("She turned, walking backward. “It’s okay. I’m fine.” Now that she was putting space between them. She held out her arms, exhibit A. “See?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41401320"
    }
  }, [_c('span', [_vm._v("The furrowed brow remained.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41408320"
    }
  }, [_c('span', [_vm._v("Reese offered what she hoped was a normal smile. “See you Monday.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticClass: "sgc-3",
    attrs: {
      "alt": "9781401684945_INT_0320_001",
      "src": "Images/9781401684945_INT_0320_001.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e41420320"
    }
  }, [_c('span', [_vm._v("Griffen watched Reese walk away until she faded into the darkness of Maple Street. He picked up the basketball and slammed it into the cement, stopping the ball when it rebounded.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41437320"
    }
  }, [_c('span', [_vm._v("Idiot! Why’d he have to take the stupid game so seriously?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41442320"
    }
  }, [_c('span', [_vm._v("He never should’ve charged into her like that. Now she was mad and probably hurt too.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41452320"
    }
  }, [_c('span', [_vm._v("He walked to the garage, tossed the ball inside, and flipped off the light. Darkness followed him as he retrieved his coat and entered his house through the side entrance. He closed the door and leaned against it. His heart was still racing, whether from the game, the fall, or what came after, who knew?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41475320"
    }
  }, [_c('span', [_vm._v("His mind zipped through the conversations they’d had earlier. The renovation project, her spinster comment . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41483320"
    }
  }, [_c('span', [_vm._v("He wondered again if she still had feelings for Sawyer. His attempt to draw her out had been pointless. She’d changed the subject pretty quick.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41497320"
    }
  }, [_c('span', [_vm._v("He hoped Reese wasn’t hurt. She was a tough girl, always had been. He’d seen her play through a sprained wrist and even the flu once when the regional championship was at stake.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41513321"
    }
  }, [_c('span', [_vm._v("What if she’d hit her head? She’d had a dazed look in her eyes as she’d stared back at him. Great. She might have a concussion, and he’d just let her walk back to town alone.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41526321"
    }
  }, [_c('span', [_vm._v("He banged his head on the door behind him. Once, twice, three times. He’d give her a few minutes to get to the coffee shop, then he’d text her and make sure she’d arrived safely.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41539321"
    }
  }, [_c('span', [_vm._v("He’d thought he was so good, playing ball with her like the old days, teasing her, taunting her. Then he’d trampled all over her like a big clumsy oaf. If he kept that up, she’d never figure it out.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e41555321"
    }
  }, [_c('span', [_vm._v("Yeah, that’s what he should do. Knock her down and bruise her up every time he saw her. Then she’d never guess the truth: that he’d fallen madly, crazily, and irrevocably in love with his best friend.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f78cc1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Hunt_9781401684952_epub_c52_r1.vue
// module id = 72
// module chunks = 0